import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import HeaderComponents from "../../Components/HeaderComponent";
import AddNFts from "./AddNfts";
import InfoSection from "./InfoSection";
import MLDSection from "./MLDSection";
import { ethers } from "ethers";
import environmentVariables from "../../config/environmentVariables";

const NftnotfoundImg = `${environmentVariables?.cdnUrl}notification_bg.png`
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from "@mui/material";
import {
  allMetalordNFTContractsDeployed,
} from "../NftMarket/NftMarketPage/contractData";
import ConfirmPopup from "../../Components/ConfirmPopup";
import NewSuccessPopup from "../../Components/NewSuccessPopup";
import {
  balanceOf,
  checkAllowance,
  approve,
  init,
} from "../../config/provider";
import {
  getRequiredLord,
  getWithdrawalFeesPercentage,
  getLordBurnPercentage,
  getStakers,
  getStakedTokens,
  decodeData,
  isApprovedForAll,
  nftApprove,
  setStake,
  setWithdraw,
  setClaimRewards,
  getTokenOfOwnerByIndex,
} from "./nftContractData";
import { makeStyles } from "@mui/styles";
import {
  nftStakingAddress,
  nftContractABI,
} from "../../config/data";
import NftPoolStacking from "./NftPoolStacking";
import CircularLoader from "../../Components/CircularLoader/CircularLoader";
import { userInfoContext } from "../../context/userInfoContext";
import { toast } from "react-toastify";
import TransactionLoader from "../../Components/TransactionLoader/TransactionLoader";
import { gasEstimateClaimRewards } from "../../config/gasEstimation";
import LowBalancePopUp from "../../Components/LowBalancePopUp/LowBalancePopUp";
import { formatNumber } from "../../config/common";
const Root = styled.div``;
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  @media (max-width: ${(p) => p.theme.screen.lg}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: calc(100% - 40px);
  }
`;

const ButtonContainer = styled.div`
  background-color: ${(p) => p.theme.colors.green};
  width: 200px;
  display: flex;
  justify-content: space-between;
  border-radius: ${(p) => p.theme.radius.xl};
  @media (min-width: 1600px) {
  }
`;
const NftnotfoundMain = styled.div`
  background-image: url(${NftnotfoundImg});
  margin-top: 100px;
  height: 513px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 46px;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  text-transform: uppercase;
  background-position: center;
`;
const DialogStyledUpdate = styled(Dialog)``;

const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "50px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "360px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));
const Button = styled.button`
  width: 48%;
  display: flex;
  background: none;
  border: none;
  /* cursor: pointer; */
  padding: ${(p) => p.theme.spacing.xs} 0;
  align-items: center;
  margin-top: 0;
  justify-content: center;
  border: 1px solid white;
  border-radius: 50px;
  padding: 10px 0;
  font-size: 18px;
  background-color: white;
  margin: 0px 0 50px 0;
  cursor: pointer;
  // color: ${(p) => p.theme.colors.skyColor};
  color: #000;
  :hover {
    background-color: #1c83999e;
    border: 1px solid #1c83999e;
    transition: 0.5s;
    color: white;
  }
  /* ${(p) =>
    p.selected &&
    `
  background-color:${p.theme.colors.skyColor};
  border-radius:${p.theme.radius.xl};
  color:${p.theme.colors.black};
`} */
`;

const Text = styled.text`
  font-size: 2.125rem;
  font-weight: 600;
  font-family: "SweraDemo";
  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 1024px) {
    font-size: 24px;
  }
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -30px;
    ${'' /* right: 85px; */}
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;

const NftNameConfirmHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  max-height: 35px;
  justify-content: space-between;
  width: 105px;
`;
const NftNameConfirm = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
  ${(p) => {
    p.ConfirmPopup &&
      `
   justify-content: flex-start;
  `;
  }}
`;
const NftNameConfirmHead = styled.div`
  font-size: 32px;
  font-weight: 600;
  // text-align: center;
`;
const TextNoData = styled.text`
  font-size: 18px;
  font-weight: 500;
  color: #e1e1e1;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const NoStakedWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 60px 0px 30px;
`;
const PayButtons = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const ButtonConfirm = styled.button`
  background: linear-gradient(45deg, #0a5d6e, #00aacd);
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 24px;
  padding: 20px 80px;
  margin: 40px 0 10px;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
  }
`;

const Pool = ({ allContractDetails, setAllContractDetails }) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [showDepositPopup, setShowDepositPopup] = useState(false);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const { userAccInfo, setUserAccInfo } = useContext(userInfoContext);
  const [userBalance, setUserBalance] = useState({
    LORDBalance: 0,
    LORD: 0,
    RequiredLord: 0,
  });
  const [allowance, setAllowance] = useState({
    LORDAllowance: 0,
  });
  const [withdrawalFeesPerc, setWithdrawalFeesPercentage] = useState(null);
  const [lordBurnPerc, setLordBurnPercentage] = useState(null);
  const [stakers, setStakers] = useState(0);
  const [perform, setPerform] = useState("");
  const [isWithdraw, setIsWithdraw] = useState(false);
  const [LordinfoOpen, setLordinfoOpen] = useState(false);
  const [unclaimed, setUnclaimed] = useState(0);
  const [rewardInfoOpen, setRewardInfoOpen] = useState(false);
  const [HashinfoOpen, setHashinfoOpen] = useState(false);
  const [stakedLoader, setStakedLoader] = useState(false);
  const [metaspaceBaseURL, setMetaspaceBaseApiURL] = useState(null);
  const [stakedDetail, setStakedDetail] = useState({
    decodedHexData: null,
    timeStampArray: null,
  });
  const [staker, setStakerData] = useState({
    decodedHexData: [],
    timeStampArray: null,
  });
  const [nftList, setNftList] = useState([]);
  const [userHash, setUserHash] = useState(0);
  const [userEarnings, setUserEarnings] = useState(0);
  const [page, setPage] = useState("nft pool");
  const [message, setMessage] = useState("");
  const [isWithdrawError, setIsWithdrawError] = useState(false);
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [showdata, setShowData] = useState();
  const [transactionHash, setTransactionHash] = useState("");
  const [transactionFee, setTransactionFee] = useState(0);
  const [myNFTDetails, setMyNFTDetails] = useState(null);
  const [nftDetailsOfWithdraw, setNftDetailsOfWithdraw] = useState(null);
  const addErrorLogs = async (type, error) => {
    try {
      let data = {
        type: type,
        error: error,
        user_address: allContractDetails?.address,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_error_log`,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${userAccInfo}`
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const addInitiatedTransactions = async (contract, token, type) => {
    try {
      let data = {
        type: type,
        user_address: allContractDetails?.address,
        contract_address: contract,
        token_id: token,
      };

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/add_initiated_trxs`,

        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error, "initiated transaction error");
        });
    } catch (err) {
      console.log(err, "initiated transaction error");
    }
  };
  const HandlePlateformdata = () => {
    axios
      .get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/nftearning`)
      .then((response) => {
        // console.log("pooldata", response.data),
        setShowData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getUserHash = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserhashinfo/${allContractDetails?.address}`
      )
      .then((res) => {
        console.log(res?.data, "props inside stakingsection");
        setUserHash(res?.data[0]?.totalHash);
        setUserEarnings(res?.data[0]?.totalEarnings);
        setUnclaimed(res?.data[0]?.totalUnclaimed);
        // console.log(
        //   res.data[0]?.totalHash,
        //   "userhash 000000000000000000000000"
        // );
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    setStakedLoader(true);
    HandlePlateformdata();
  }, []);
  const getStakedNFTs = () => {
    try {
      axios
        .get(
          `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/get_stakednfts/${allContractDetails?.address}`
        )
        .then((response) => {
          setStakedLoader(false);
          setStakedDetail(response?.data?.data);
        })

        .catch((error) => {
          console.log(error);
          setStakedLoader(false);
        });
    } catch (err) {
      console.log(err);
      setStakedLoader(false);
    }
  };
  useEffect(() => {
    getUserHash();
    if (allContractDetails?.address) {
      getStakedNFTs();
    }
  }, [allContractDetails]);
  // useEffect(() => {
  //   getAllTheInformation()
  // }, [])

  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails?.address.toLowerCase();
      axios
        .get(
          `${environmentVariables?.apiUrl
          }/nftmarketplace/api/v1/getmyallnfts/${address.toLowerCase()}`,
          {
            headers: {
              authorization: `Bearer ${userAccInfo}`
            }
          }
        )
        .then((res) => {
          // console.log(res.data.data, "mynftdata");
          setMyNFTDetails(res.data.data);
          const newObj = {};
          const newArr = [];
          res.data.data.map((val) => {
            const newObj1 = {};
            newObj1.address = val.contractAddress;
            newObj1.tokenID = val.tokenId;
            newObj1.nftDetail = val;
            newArr.push(newObj1);
            setLoading(false);
          });
          newObj.decodedHexData = newArr;
          newObj.timeStampArray = null;
          setStakerData(newObj);
        })
        .catch((err) => {
          console.log(err);
        });
      getAllTheInformation();
    } else {
      clearData();
    }
  }, [allContractDetails]);

  const getNftData = async (array) => {
    setLoading(true);
    let pdd = [];
    const list = array?.map(async (ddf, i) => {
      if (i >= 8) {
        return;
      }
      // console.log("hello");
      const tokenId = await getTokenOfOwnerByIndex(
        ddf.nftContract,
        ddf.address,
        ddf.index
      );
      try {
        // console.log(
        //   "ddf.contractAdd",
        //   ddf.contractAdd,
        //   "tokenId",
        //   tokenId,
        //   "ddf.url",
        //   ddf.url
        // );
        const nftDetail = await fetchNftDetail(
          ddf.contractAdd,
          tokenId,
          ddf.url
        );
        pdd.push({
          address: ddf.contractAdd,
          tokenID: parseInt(tokenId),
          nftDetail: nftDetail,
        });
      } catch (error) {
        console.log("error", error);
        pdd.push({ address: ddf.contractAdd, tokenID: parseInt(tokenId) });
      }
    });
    // Promise.all(list).then(() => {
    // setStakerData({
    //   decodedHexData:
    //     staker.decodedHexData.length > 0
    //       ? [...staker.decodedHexData, ...pdd]
    //       : pdd,
    // });
    // setNftList((prevNftList) => {
    //   const remainData = prevNftList.slice(8);
    //   return remainData;
    // });
    // });
    setLoading(false);
  };

  // console.log("nftList", staker.decodedHexData);

  const clearData = () => {
    setDefaultAccount(null);
    setUserBalance({
      LORDAllowance: 0,
      LORD: 0,
    });
    setAllowance({
      MLDAllowance: 0,
      LORDAllowance: 0,
    });
    setWithdrawalFeesPercentage(0);
    setLordBurnPercentage(0);
    setStakers(null);
    setMetaspaceBaseApiURL("");
    setStakedDetail({
      decodedHexData: null,
      timeStampArray: null,
    });
    setStakerData({
      decodedHexData: [],
      timeStampArray: null,
    });
  };

  function toAsciiHex(address) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
      throw new Error("Invalid Ethereum address");
    }

    address = address.replace(/^0x/i, "");
    let asciiHex = "";

    for (let i = 0; i < address.length; i += 2) {
      const byte = address.substr(i, 2);
      asciiHex += String.fromCharCode(parseInt(byte, 16));
    }

    return "0x" + Buffer.from(asciiHex, "ascii").toString("hex");
  }

  const getDecodeHashData = async (array, url) => {
    const arr = [];

    for (let index = 0; index <= array.length - 1; index++) {
      const hashed = await decodeData(
        allContractDetails?.nftStakingContract,
        array[index]
      );
      try {
        const nftDetail = await fetchStakedNFTDetails(
          toAsciiHex(hashed[0]),
          parseInt(hashed[1]),
          url
        );
        arr.push({
          address: hashed[0],
          tokenID: parseInt(hashed[1]),
          nftDetail: nftDetail,
        });
      } catch (error) {
        addErrorLogs("fetchStakedNFTDetails", JSON.stringify(error));
        arr.push({ address: hashed[0], tokenID: parseInt(hashed[1]) });
      }
    }

    return arr;
  };

  const fetchNftDetail = async (address, index, url) => {
    return myNFTDetails.filter((val) => val.tokenId === index);
  };
  const handleLogin = () => {
    try {
      init()
        .then((res) => {
          setAllContractDetails(res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };
  const fetchStakedNFTDetails = async (address, index, url) => {
    return axios
      .get(`${url}/${address.toLowerCase()}/${index}`)
      .then((res) => res.data)
      .catch((err) => err);
  };
  const getAllStakerData = async (address, url, allNftContract) => {
    const arr = [];
    for (let index = 0; index <= allNftContract.length - 1; index++) {
      const contractAdd = allNftContract[index];
      const nftContract = await getNFTContract(contractAdd);
      const lordBal = (await balanceOf(nftContract, address)) || 0;
      for (let index = 0; index < parseInt(lordBal); index++) {
        arr.push({
          nftContract,
          address,
          index,
          contractAdd,
          url,
        });

        // const tokenId = await getTokenOfOwnerByIndex(
        //   nftContract,
        //   address,
        //   index
        // );
        // try {
        //   const nftDetail = await fetchNftDetail(contractAdd, tokenId, url);
        //   arr.push({
        //     address: contractAdd,
        //     tokenID: parseInt(tokenId),
        //     nftDetail: nftDetail,
        //   });
        // } catch (error) {
        //   console.log("error", error);
        //   arr.push({ address: contractAdd, tokenID: parseInt(tokenId) });
        // }
      }
    }

    setNftList(arr);
    getNftData(arr);
  };

  const getTimeStamp = async (array) => {
    return await array.map((time) => parseInt(time));
  };

  const getTheAllStakedDetail = async (stakedTokens, url) => {
    const decodedHexData = await getDecodeHashData(stakedTokens[0], url);
    const timeStampArray = await getTimeStamp(stakedTokens[1]);
    return {
      decodedHexData,
      timeStampArray,
    };
  };

  const getAllNftMarketplaceList = async () => {
    let i = 0;
    let arr = [];
    while (i !== null) {
      await allMetalordNFTContractsDeployed(
        allContractDetails?.metalordNFTManagerContract,
        i
      )
        .then(async (res) => {
          if (res !== null) {
            // console.log("res", res);
            arr.push(res);
          }
          i++;
        })
        .catch((err) => {
          i = null;
        });
    }

    return arr; // address array
  };

  const getAllTheInformation = async () => {
    setLoading(true);
    const address = allContractDetails?.address;
    setDefaultAccount(address);

    const lordBal =
      (await balanceOf(allContractDetails?.lordTokenContract, address)) || 0;
    const requiredLord =
      (await getRequiredLord(allContractDetails?.nftStakingContract)) || 0;

    setUserBalance({
      LORDBalance: parseInt(lordBal),
      LORD: parseFloat(ethers.formatEther(lordBal)).toFixed(2),
      RequiredLord: parseFloat(ethers.formatEther(requiredLord)).toFixed(
        2
      ),
    });

    setAllowance({
      LORDAllowance: parseInt(
        await checkAllowance(
          allContractDetails?.lordTokenContract,
          address,
          nftStakingAddress
        )
      ),
    });

    const withdrawalFeesPercentage =
      (await getWithdrawalFeesPercentage(
        allContractDetails?.nftStakingContract
      )) || 0;
    const lordBurnPercentage =
      (await getLordBurnPercentage(allContractDetails?.nftStakingContract)) ||
      0;
    const staker =
      (await getStakers(allContractDetails?.nftStakingContract, address)) || 0;
    const stakedTokens =
      (await getStakedTokens(
        allContractDetails?.nftStakingContract,
        address
      )) || 0;
    // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(
    //   allContractDetails?.nftStakingContract
    // );
    const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details`;

    setWithdrawalFeesPercentage(
      parseFloat(withdrawalFeesPercentage).toFixed(2)
    );
    setLordBurnPercentage(parseFloat(lordBurnPercentage).toFixed(2));
    setStakers(parseFloat(ethers.formatEther(staker)).toFixed(2));
    setMetaspaceBaseApiURL(metaspaceBaseApiURL);

    const getStakersDetail = await getTheAllStakedDetail(
      stakedTokens,
      `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details`
    );
    console.log(getStakersDetail, "pooldatanft");
    // setStakedDetail(getStakersDetail);
    setStakedLoader(false);
    // console.log(getStakersDetail, "subhn");
    const allNftContract = await getAllNftMarketplaceList();
    // console.log("allNftContract", allNftContract);
    await getAllStakerData(address, metaspaceBaseApiURL, allNftContract);
    // console.log("stakerList", stakerList);
    // setStakerData({
    //   decodedHexData: stakerList,
    // });
    setLoading(false);
  };

  const callStake = async (nftAddress, tokenID) => {
    await addInitiatedTransactions(nftAddress, tokenID, "stake");
    await setStake(allContractDetails?.nftStakingContract, nftAddress, tokenID)
      .then((res) => {
        if (res !== null) {
          axios
            .post(
              `${environmentVariables?.apiUrl
              }/nftmarketplace/api/v1/changestakingstatus/${nftAddress.toLowerCase()}/${tokenID}`,
              { isStaked: true },
              {
                headers: {
                  authorization: `Bearer ${userAccInfo}`
                }
              }
            )
            .then((res) => {
              setLoading(false);
              setPerform("Staked");
              setShowDepositPopup(true);
              setMessage("Your stake has been listed.");
            })
            .catch((err) => {
              setLoading(false);
              setPerform("Staked");
              // setShowDepositPopup(true);
              setMessage(err?.message || "Something went wrong");
            });
        }
      })
      .catch((err) => {
        addErrorLogs("stakeNFT", JSON.stringify(err));
        setLoading(false);
        setMessage(
          err?.response?.data?.message || err?.message || "Something went wrong"
        );
        setShowCreatedPopup(true);
        // console.log(
        //   "err",
        //   err.error.data.message || err.message || "Something went wrong"
        // );
      });
  };

  const callWithdraw = async (nftAddress, tokenID, nftDetails) => {
    console.log(nftDetails, "nftdetails of withdraw");
    setNftDetailsOfWithdraw(nftDetails);
    // setShowDepositPopup(true);
    // setLoading(false);
    setIsWithdraw(false);
    try {
      setLoading(true);
      await addInitiatedTransactions(nftAddress, tokenID, "unstake");
      await setWithdraw(
        allContractDetails?.nftStakingContract,
        nftAddress,
        tokenID
      )
        .then((res) => {
          if (res !== null) {
            if (res?.hash || res?.transactionHash) {
              let data = {
                isStaked: false,
              };

              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/changestakingstatus/${nftAddress}/${tokenID}`,
                headers: {
                  authorization: `Bearer ${userAccInfo}`
                },
                data: data,
              };

              axios
                .request(config)
                .then((response) => {
                  setLoading(false);
                  setPerform("Withdraw");
                  setShowDepositPopup(true);
                  setTransactionHash(res?.hash || res?.transactionHash);
                  setTransactionFee(
                    parseFloat(
                      (Number(res?.gasLimit || res?.gasUsed || res?.effectiveGasPrice?._hex) *
                        Number(res?.gasPrice || res?.gasUsed?._hex)) /
                      1000000000000000000
                    ).toFixed(4)
                  );
                  axios
                    .get(
                      `${environmentVariables?.redisUrl}/nftmarketplace/api/v1/cleardata`
                    )
                    .then((res) => console.log(res))
                    .catch((err) => console.log(err));
                  setIsWithdraw(false);
                })
                .catch((error) => {
                  setLoading(false);
                  console.log("err===>", err?.response?.data?.message);
                  setIsWithdraw(false);
                  setMessage(err?.response?.data?.message || err?.message || "Something went wrong");
                  setIsWithdrawError(true);
                });
            }
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log("err===>", err?.error?.data?.message);
          setIsWithdraw(false);
          setMessage(err?.error?.data?.message || err?.message || "Something went wrong");
          setIsWithdrawError(true);
        });
    } catch (err) {
      console.log(err);
      addErrorLogs("withdrawNFT", JSON.stringify(err));
    }
  };

  const callReward = async () => {
    setLoading(true);
    await setClaimRewards(allContractDetails?.nftStakingContract)
      .then((res) => {
        if (res !== null) {
          setLoading(false);
          setPerform("Reward");
          setShowDepositPopup(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
      });
  };

  
  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };
  const loadStakedNFTsComponents = () => {
    if (!allContractDetails) {
      return (
        <>
          <TextContainer>
            <Text>Staked NFT </Text>
            <NoStakedWrapper>
              <TextNoData>Login to view Staked NFTs</TextNoData>
            </NoStakedWrapper>
            <div
              style={{
                background: "#172930",
                borderRadius: "50px",
                fontSize: "15px",
                cursor: "pointer",
                fontWeight: "600",
                border: "1px solid #153339",
                padding: "12px 30px",
                color: "#267383",
                width: "140px",
                margin: "0 auto",
                textAlign: "center",
              }}
              onClick={handleLogin}
            >
              Login
            </div>
          </TextContainer>
        </>
      );
    } else if (stakedLoader == true && defaultAccount !== null) {
      return (
        <>
          <Text>Staked NFT </Text>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularLoader></CircularLoader>
          </div>
        </>
      );
    } else {
      if (
        stakedDetail?.decodedHexData &&
        stakedDetail?.decodedHexData?.length > 0
      ) {
        return (
          <>
            <Text>Staked NFT </Text>
            <AddNFts
              setMessage={setMessage}
              setIsWithdrawError={setIsWithdrawError}
              isWithdraw={isWithdraw}
              setIsWithdraw={setIsWithdraw}
              userAddress={allContractDetails?.address}
              withdraw={callWithdraw}
              listDetail={stakedDetail}
              viewMoreBtn={false}
            />
          </>
        );
      } else {
        return (
          <>
            <TextContainer>
              <Text>Staked NFT </Text>
              <NoStakedWrapper>
                <TextNoData>No NFT Staked</TextNoData>
              </NoStakedWrapper>
            </TextContainer>
          </>
        );
      }
    }
  };
  const loadUserNFTsComponents = () => {
    if (loading == true) {
      return (
        <>
          <Text>NFT Owned by User </Text>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularLoader></CircularLoader>
          </div>
        </>
      );
    } else {
      if (staker?.decodedHexData && staker?.decodedHexData?.length > 0) {
        return (
          <>
            <Text>NFT Owned by User </Text>
            <AddNFts
              stake={stake}
              listDetail={staker}
              getNftData={getNftData}
              nftList={nftList}
              viewMoreBtn={true}
            />
          </>
        );
      } else {
        return (
          <>
            <Text>NFT Owned by User </Text>
            <NftnotfoundMain>
              {/* <Nftnotfound src={NftnotfoundImg} /> */}
              You Don't Have NFT's
            </NftnotfoundMain>
          </>
        );
      }
    }
  };
  const stake = async (nftAddress, tokenID) => {
    setLoading(true);
    const balanceLord = Number(userBalance.LORD);
    const allowanceLord = Number(allowance.LORDAllowance);
    const requiredLord = Number(userBalance.RequiredLord);
    const nftContract = await getNFTContract(nftAddress);

    const getIsApprovedForAll = await isApprovedForAll(
      nftContract,
      defaultAccount,
      nftStakingAddress
    );

    if (balanceLord >= requiredLord) {
      if (allowanceLord >= requiredLord && getIsApprovedForAll === true) {
        await callStake(nftAddress, tokenID);
      } else {
        if (allowanceLord < requiredLord) {
          await approve(
            allContractDetails?.lordTokenContract,
            nftStakingAddress,
            allContractDetails?.provider
          );
        }

        if (getIsApprovedForAll !== true) {
          await nftApprove(nftContract, nftStakingAddress,allContractDetails?.provider);
        }

        await callStake(nftAddress, tokenID);
      }
    } else {
      // alert("not enough balance");
      toast.warning("not enough balance")
      setLoading(false);
    }
  };

  const depositPopup = async () => {
    setShowDepositPopup(false);
    await clearData();
    await getAllTheInformation();
  };

  // console.log("stacker, stakedetals", staker, stakedDetail);
  // console.log("stakedata", showdata);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // New state to manage popup visibility
  const [poppuploader, setpoppuploader] = useState(false);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [istransactionloader, setIstransactionloader] = useState(false);
  const [gaspopuperror, setgaspoperror] = useState(false);
  const [isgaserror, setIsgaserror] = useState(false);
  const [gasFees, setGasfees] = useState(0);
  const [transactionFees,setTransactionFees]=useState();
  const [isBalanceMatic, setBalanceMatic] = useState(false);
  const [lowBalancePopUp, setLowBalancePopup] = useState(false);

  const handleClaimReward = async () => {
    setpoppuploader(true)
    const gasFeesdata = await gasEstimateClaimRewards(allContractDetails?.address);
    setGasfees(gasFeesdata);
    console.log(typeof (gasFeesdata))
    console.log("gasfees error---------->", gasFeesdata, ';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')



    let maticBalance = parseFloat(ethers.formatEther(`${parseFloat(allContractDetails?.maticBal)}`))
    maticBalance=parseFloat(userBalance?.MATIC)
    console.log("userbalanec-------------->", maticBalance)
    if (maticBalance < 0.1) {
      setBalanceMatic(true);
      setLowBalancePopup(true);
      setpoppuploader(false)
    }
    else {
      if (typeof gasFeesdata === 'string') {
        // setTimeout(() => {
        //   // setpoppuploader(false);
        //   setIsPopupOpen(true);
        // }, 1000);
        
        setIsgaserror(true);
        setpoppuploader(false);
        

      }
      else {
        // console.log('gas pop up opened')
        // setgaspoperror(false);
        setIsPopupOpen(true);
        setpoppuploader(false);
        // setpoppuploader(true)
        // setTimeout(() => {
        //   // setIsgaserror(true);
        //   setpoppuploader(false)
        // }, 1000)


      }
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false); // Close the popup
    setgaspoperror(false);
    setIsgaserror(false);
  };
  // const handlegasClosePopup = () => {
  //   setgaspoperror(false);
  // }
  const handleConfirm = async () => {
    setIsPopupOpen(false); // Close the popup after confirmation
    setIstransactionloader(true);
    await setClaimRewards(allContractDetails?.nftStakingContract).then(res=>{
      if(res!=null){
        console.log(res,'[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[');
        setTransactionHash(res?.hash||res?.transactionHash);
        let gasLimitHex = res?.gasLimit || res?.gasUsed || res?.effectiveGasPrice?._hex;
        // console.log(gasLimitHex, "responseafterbuy");

        let gasPriceHex = res?.gasPrice || res?.gasUsed?._hex;
        // console.log(gasPriceHex, "responseafterbuy");

        let gasLimitBN = ethers.toBigInt(gasLimitHex);
        // console.log(gasLimitBN, "responseafterbuy");

        let gasPriceBN = ethers.toBigInt(gasPriceHex);
        // console.log(gasPriceBN, "responseafterbuy");

        let totalCostWei = Number(gasLimitBN)*Number(gasPriceBN);

        let totalCostEth = ethers.formatEther(totalCostWei.toString());
        let totalCostDecimal = parseFloat(totalCostEth);
        setTransactionFees(totalCostDecimal);
        setIstransactionloader(false);
        setIsSuccessPopupOpen(true);
      }
    }).catch(err=>{
      console.log(err);
      // setIsgaserror(true);
      // setgaspoperror(true);
      setIstransactionloader(false);

      setGasfees(err?.response?.data?.message||err?.message||"Something went wrong");
      setIsgaserror(true);
    })
    // setTimeout(() => {
    //   setIstransactionloader(false);
    //   setIsSuccessPopupOpen(true);
    // }, 5000)
  };
  // const handleConfirm = async () => {
  //   setIsPopupOpen(false); // Close the popup after confirmation
  //   setgaspoperror(false)
  //   setIsSuccessPopupOpen(true);
  //   setTimeout(() => {
  //     setIstransactionloader(true);
  //   }, 5000)
  // };
  return (
    <>
      {/* {loading && <Loading />} */}
      <Root
        onClick={() => {
          setHashinfoOpen(false);
          setLordinfoOpen(false);
        }}
      >
        <DialogStyledUpdate
          open={isWithdrawError}
          onClose={() => setIsWithdrawError(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { overflow: "initial", backgroundColor: "transparent" },
          }}
        >
          <ButtonCancel
            onClick={() => setIsWithdrawError(false)}
            color="primary"
          >
            X
          </ButtonCancel>
          <div className={classes.customButton}>
            <NftNameConfirm>
              <NftNameConfirmHead>{message}</NftNameConfirmHead>
            </NftNameConfirm>
          </div>
        </DialogStyledUpdate>
        <Container>
          <HeaderComponents title="META POOL" />
          {/* <ButtonContainer>
            <Button
              selected={page === "nft pool 2.0"}
              onClick={() => {
                setPage("nft pool 2.0");
              }} 
              
            >
              NFT Pool
            </Button>
            <Button selected={page === 'nft pool'} onClick={() => { setPage('nft pool') }}>NFT Pool</Button>
          </ButtonContainer> */}
          <MLDSection showdata={showdata} setShowData={setShowData} />
          <InfoSection
            userHash={userHash}
            unclaimed={unclaimed}
            userEarnings={userEarnings}
            withdrawalFeesPerc={withdrawalFeesPerc}
            stakers={stakers}
            showdata={showdata}
            setShowData={setShowData}
            LordinfoOpen={LordinfoOpen}
            setLordinfoOpen={setLordinfoOpen}
            rewardInfoOpen={rewardInfoOpen}
            setRewardInfoOpen={setRewardInfoOpen}
            HashinfoOpen={HashinfoOpen}
            setHashinfoOpen={setHashinfoOpen}
          />

          {/* {Number(stakers)>0&&<Button
            onClick={() => {
              callReward();
            }}
          >
            Claim Rewards
          </Button>} */}

          <NftPoolStacking
            userHash={userHash}
            withdrawalFeesPerc={withdrawalFeesPerc}
            stakers={stakers}
            showdata={showdata}
            setShowData={setShowData}
          />

          {/* Address: {defaultAccount}
          <br />
          Lord Balance: {userBalance.LORD}
          <br />
          LORD Allowance: {allowance.LORDAllowance}
          <br />
          RequiredLord: {userBalance.RequiredLord}
          <br />
          withdrawalFeesPerc : {withdrawalFeesPerc}
          <br />
          lordBurnPerc : {lordBurnPerc}
          <br />
          user total unclaimed reward : {stakers}
          <br />
          metaspaceBaseURL : {metaspaceBaseURL}
          <br /> */}

          {/* {stakers > 0 && (
          //   <Button
          //     onClick={() => {
          //       callReward();
          //     }}
            
          //   >
          //     Claim Rewards
          //   </Button>
          // )} */}


          {stakers > 0 && (
            <Button onClick={handleClaimReward}>Claim Rewards</Button>
          )}

          {/* The popup for Claim Rewards Arun*/}
          <DialogStyledUpdate
            open={isPopupOpen} // Use the state to control popup visibility
            onClose={handleClosePopup} // Close the popup when clicking outside or "X"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { overflow: "initial", backgroundColor: "transparent" },
            }}
          >
            <ButtonCancel onClick={handleClosePopup} color="primary">
              X
            </ButtonCancel>
            <div className={classes.customButton}>
              <NftNameConfirm>
                <NftNameConfirmHead>{message}</NftNameConfirmHead>
              </NftNameConfirm>
              <DialogActions>
                <PayButtons>
                  <ButtonConfirm
                    onClick={handleConfirm} // Action when "Confirm" is clicked
                    color="primary"
                    autoFocus
                  >
                    Confirm
                  </ButtonConfirm>
                </PayButtons>
              </DialogActions>
            </div>
          </DialogStyledUpdate>

          {/* {isSuccessPopupOpen && (!istransactionloader ? <TransactionLoader /> : (
            <NewSuccessPopup
              showPopup={showDepositPopup}
              setShowPopup={setShowDepositPopup}
              popUpText={`Rewards Claimed`}
              onClickFun={depositPopup}
              transactionHash={transactionHash}
              transactionFee={gasFees.toFixed(4)}
              price={nftDetailsOfWithdraw?.price}
              fetchDetails={nftDetailsOfWithdraw}
              currency={nftDetailsOfWithdraw?.currency}
              text={`Congratulation you ${perform} successfully.`}
            ></NewSuccessPopup>
          ))} */}

            {istransactionloader?<TransactionLoader/>:<>{isSuccessPopupOpen&&<NewSuccessPopup
              showPopup={isSuccessPopupOpen}
              setShowPopup={setIsSuccessPopupOpen}
              popUpText={`Rewards Claimed`}
              onClickFun={depositPopup}
              transactionHash={transactionHash}
              transactionFee={transactionFees.toFixed(4)}
              price={unclaimed}
              fetchDetails={nftDetailsOfWithdraw}
              currency={'MLD'}
              text={`Congratulation you Claimed Reward successfully.`}
            ></NewSuccessPopup>}</>}

          {/* the  gas popup error */}


          {poppuploader ? <TransactionLoader isEstimate={true} /> : (
            <DialogStyledUpdate
              open={isgaserror}
              // onClose={() => setIsgaserror(false)}
              onClose={handleClosePopup}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                sx: { overflow: "initial", backgroundColor: "transparent" },
              }}
            >
              <ButtonCancel onClick={handleClosePopup} color="primary">
                X
              </ButtonCancel>

              <div className={classes.customButton}>
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    textAlign: "center",
                    fontSize: "28px",
                    fontWeight: "500",
                    padding: "0",
                  }}
                >
                  {gasFees}
                </DialogTitle>


              </div>
            </DialogStyledUpdate>
          )}


          {/* The popup for Claim Rewards */}

          {
           isBalanceMatic ?







              // <DialogStyledUpdate
              //   open={lowBalancePopUp}
              //   onClose={() => setLowBalancePopup(false)}
              //   aria-labelledby="alert-dialog-title"
              //   aria-describedby="alert-dialog-description"
              //   PaperProps={{
              //     sx: { overflow: "initial", backgroundColor: "transparent" },
              //   }}
              // >
              //   <ButtonCancel
              //     onClick={() => setLowBalancePopup(false)}
              //     color="primary"
              //   >
              //     X
              //   </ButtonCancel>
              //   <div className={classes.customButton}>
              //     <NftNameConfirm>
              //       <NftNameConfirmHead>Insufficient Balance</NftNameConfirmHead>
              //     </NftNameConfirm>
              //     <DialogActions>
              //       <PayButtons>
              //         <ButtonConfirm
              //           onClick={handleConfirm} 
              //           color="primary"
              //           autoFocus
              //         >
              //           buy
              //         </ButtonConfirm>
              //       </PayButtons>
              //     </DialogActions>
              //   </div>
              // </DialogStyledUpdate>
              
              <LowBalancePopUp message={`Insufficient POL`} currency={'POL'}  setIsStakeError={setBalanceMatic} isStakeError={isBalanceMatic}/>
              
              
              
              
              
              
              
              
              
              
              
              
              
              :( poppuploader ? <TransactionLoader isEstimate={true} /> :
                <DialogStyledUpdate
                  open={isPopupOpen}
                  onClose={handleClosePopup}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  PaperProps={{
                    sx: { overflow: "initial", backgroundColor: "transparent", width: "650px" },
                  }}
                >
                  <ButtonCancel onClick={handleClosePopup} color="primary">
                    X
                  </ButtonCancel>

                  <div className={classes.customButton}>

                    <DialogTitle
                      id="alert-dialog-title"
                      style={{
                        textAlign: "left",
                        fontSize: "28px",
                        fontWeight: "500",
                        padding: "0",
                      }}
                    >
                      Claim Rewards
                    </DialogTitle>


                    <DialogContent style={{ padding: "0 0 40px" }}>
                      <DialogContentText
                        id="alert-dialog-description"
                        style={{
                          textAlign: "left",
                          color: "#bbb",
                          fontSize: "16px",
                        }}
                      >
                        Double-check your details to complete the transaction
                      </DialogContentText>
                    </DialogContent>

                    <hr style={{ border: "1px solid #ccc", margin: "-10px 0 20px 0" }} />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginBottom: "10px",
                      }}
                    >
                      <span>Unclaimed Claim Rewards:</span>
                      <span>{formatNumber(unclaimed)} $MLD</span>
                    </div>

                     <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginBottom: "10px",
                      }}
                    >
                      <span>{`Withdrawl Fee (10%):`}</span>
                      <span>{formatNumber(unclaimed*0.1)} $MLD</span>
                    </div>


                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginBottom: "10px", // Adding space below this section
                      }}
                    >
                      <span>Transaction Fees:</span>
                      <span>{parseFloat(gasFees).toFixed(4)} POL</span>
                    </div>

                    {/* Confirmation button with original structure */}
                    <DialogActions>
                      <PayButtons>
                        <ButtonConfirm
                          onClick={handleConfirm} // Action when "Confirm" is clicked
                          color="primary"
                          autoFocus
                        >
                          Confirm
                        </ButtonConfirm>
                      </PayButtons>
                    </DialogActions>
                  </div>
                </DialogStyledUpdate>)
          }

          <div>{loadStakedNFTsComponents()}</div>
          <br />
          {/* <div>{loadUserNFTsComponents()}</div> */}
          {showDepositPopup && (
            <ConfirmPopup
              showPopup={showDepositPopup}
              setShowPopup={setShowDepositPopup}
              popUpText={`NFT Unstaked`}
              onClickFun={depositPopup}
              transactionHash={transactionHash}
              transactionFee={transactionFee}
              price={nftDetailsOfWithdraw?.price}
              fetchDetails={nftDetailsOfWithdraw}
              currency={nftDetailsOfWithdraw?.currency}
              text={`Congratulation you ${perform} successfully.`}
            ></ConfirmPopup>
          )}
          {showCreatedPopup && (
            <ConfirmPopup
              showPopup={showCreatedPopup}
              setShowPopup={setShowCreatedPopup}
              onClickFun={() => {
                setShowCreatedPopup(false);
              }}
              text={message}
            ></ConfirmPopup>
          )}
        </Container>
      </Root>
    </>
  );
};

export default Pool;
